import { memo, type ReactNode } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

import OrganizationAvatar, {
  OrganizationAvatarWrapper,
} from './OrganizationAvatar';

import type { Showcase } from '@src/types.ts/story';

type OrganizationAvatarWithTooltipProps = {
  album?: Showcase | null;
  username?: string | null;
  logoSize?: number;
  renderReactTooltip: () => ReactNode;
};

function OrganizationAvatarWithTooltip({
  album,
  username,
  logoSize = 34,
  renderReactTooltip,
}: OrganizationAvatarWithTooltipProps) {
  if (!album) {
    return null;
  }
  return (
    <>
      <AvatarWrapper
        data-tooltip-id="org-avatar-tooltip"
        data-tooltip-content="-"
      >
        <OrganizationAvatar
          album={album}
          username={username}
          logoSize={logoSize}
        />
      </AvatarWrapper>
      <TooltipWrapper>
        <ReactTooltip
          id="org-avatar-tooltip"
          render={renderReactTooltip}
          style={{
            background: 'none',
            pointerEvents: 'all',
          }}
          place="bottom"
          offset={0}
          openEvents={{
            mouseenter: false,
            click: true,
          }}
          closeEvents={{
            mouseleave: false,
            click: true,
          }}
        />
      </TooltipWrapper>
    </>
  );
}

export default memo(OrganizationAvatarWithTooltip);

const AvatarWrapper = styled(OrganizationAvatarWrapper)`
  align-items: center;
  gap: 8px;
  user-select: none;
  cursor: pointer;
`;

const TooltipWrapper = styled.div`
  --rt-opacity: 1;
`;
